import { TableCell, TableRow } from "@mui/material";

import React from "react";

const PreviousAssignmentsRow = ({ assignments }) => {
  return (
    <TableRow>
      <TableCell colSpan={6}>
        {assignments.map((assignment, index) => (
          <div key={index}>
            <p>Feedback: {assignment.feedback}</p>
          </div>
        ))}
      </TableCell>
    </TableRow>
  );
};

export default PreviousAssignmentsRow;
